import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';
// Modules
import loginRouter from './modules/login.router'
import dashboardRouter from './modules/dashboard'
import customerRouter from './modules/customer'
import sharedRouter from './modules/shared/shared.router';
import singleWindowRouter from './modules/single-window.router'
Vue.use(VueRouter)

const routes = [
  ...loginRouter,
  ...customerRouter,
  ...dashboardRouter,
  ...sharedRouter,
  ...singleWindowRouter,
  {
    path: '/',
    redirect: '/customer',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profile',
    component: () => import('@/layouts/FullWidthLayout.vue'),
    meta: {
        requiresAuth: true
    },
    children: [
      {
        path: '',
        component: ()=>import('@/views/customer/Profile.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
              {label: 'Inicio', link: '/'},
              {label: 'Perfil'}
          ]
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(){
    return{x: 0, y:0}
  }
})

router.beforeEach((to, from, next)=>{
  // Excluir ruta específica del router guard
  const detailsPath = '/dashboard/complaints-agiliza/details';
  if(to.path === detailsPath || to.path === `${detailsPath}/` || to.path.startsWith(`${detailsPath}/`)) {
    next();
    return;
  }
  
  store.dispatch('session/checkSession')
  .then(() => {
    // Verificar si es la ruta de sesiones sin userFacilitatorId para usuarios facilitadores
    if (to.name === 'SessionsAgiliza') {
      const user = store.state.session.user;
      const facilitatorGroupId = parseInt(process.env.VUE_APP_ROLE_FACILITATOR_AUTH_GROUP_ID);

      // Verificar si el usuario pertenece al grupo de facilitador
      if (user && user.groups?.length > 0) {
        const isFacilitator = user.groups.some(group => group.id === facilitatorGroupId);

        // Si es facilitador y tiene un ID válido, redirigir a su vista de sesiones específica
        if (isFacilitator && user.id) {
          next({ name: 'SessionsAgilizaFacilitator', params: { userFacilitatorId: user.id } });
          return;
        }
      }
    }
    
    if(to.matched.some(record => record.meta.requiresAuth)){
      // Verify if user is logged
      if(store.getters['session/isAuthenticated']){ 
        // Verify if user is active
        if(store.getters['session/isActive']){
          if (to?.fullPath === '/dashboard/home' || to?.fullPath?.includes('/customer') || to?.fullPath?.includes('/profile')) {
            next(true)
          } else if (store?.state?.session?.modules) {
            const list_modules = store?.state?.session?.modules?.filter(item =>{

              for(let label of to?.meta?.breadcrumb){
                if( label.label.includes(item.name)) return true
              }
            })
            if (list_modules.length > 0 || true) {
                next(true)
            } else {
                next('/dashboard/home')
            }
            
        } else {
          // consumidor financiero
         
            next('/dashboard/home')
        }
        } else {
          next('/login');
        }
      } 
      else {
        next('/login')
      }
    }  else {
      if(to.path == '/login' && store.getters['session/isActive']){
        next('/');
      } else {
        next();
      }
    }
  })
});

export default router
